import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const a=l("south_sudan",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H24V9.27193H1.89474L0 4.5Z"
                fill="black" />
            <path
                d="M1.89453 10.1143H23.9998V14.8862H1.89453V10.1143Z"
                fill="#DA121A" />
            <path
                d="M1.89474 15.7275H24V20.4995H0L1.89474 15.7275Z"
                fill="#078930" />
            <path
                d="M10.3916 12.5L0 20.5V4.5L10.3916 12.5Z"
                fill="#45B4DB" />
            <path
                d="M4.79664 14.9112L3.62191 10.0859L2.44717 14.9084L5.52507 11.9273H1.71875L4.79664 14.9084V14.9112Z"
                fill="#FCDD09" />
        </svg>
    `),o=l("south_sudan_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135967)">
                <path
                    d="M-3.14062 0.5H44.8594V24.5H-3.14062V0.5Z"
                    fill="white" />
                <path
                    d="M-3.14062 0.5H44.8594V7.65789H0.648849L-3.14062 0.5Z"
                    fill="black" />
                <path
                    d="M0.648438 8.9209H44.859V16.0788H0.648438V8.9209Z"
                    fill="#DA121A" />
                <path
                    d="M0.648849 17.3418H44.8594V24.4997H-3.14062L0.648849 17.3418Z"
                    fill="#078930" />
                <path
                    d="M17.6425 12.5L-3.14062 24.5V0.5L17.6425 12.5Z"
                    fill="#45B4DB" />
                <path
                    d="M6.45266 16.1168L4.10319 8.87891L1.75372 16.1126L7.90951 11.641H0.296875L6.45266 16.1126V16.1168Z"
                    fill="#FCDD09" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135967">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as SouthSudan,o as SouthSudanRounded};
